<template>
    <div v-if="modalErrors.length || modalMessages.length" class="modal-alerts">

        <!-- Modal errors -->
        <div 
            v-for="(errorMsg, index) in modalErrors" 
            :key="'modal-error-'+index" 
            class="alert alert-danger alert-dismissible fade show" role="alert">
            <div>{{ errorMsg }}</div>
            <button @click="dismissModalError(index)" type="button" class="close" aria-label="Close">&times;</button>
        </div>


        <!-- Modal messages -->
        <div 
            v-for="(msg, index) in modalMessages" 
            :key="'modal-message-'+index" 
            class="alert alert-info alert-dismissible fade show" role="alert">
            <div>{{ msg }}</div>
            <button @click="dismissModalMessage(index)" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">&times;</button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Alerts',
    props: {
        modalErrors:  Array,
        modalMessages: Array
    },
    methods: {
        dismissModalError(index) {
            this.$emitter.emit('dismissModalError', index);
        },
        dismissModalMessage(index) {
            this.$emitter.emit('dismissModalMessage', index);
        }
    }
}
</script>

<style scoped>
.modal-alerts {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .75);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 99999;
}
.alert {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 700px;
    word-break: break-all;
}
.close {
    font-size: 32px;
}
</style>
